<template> 
  <div style="background-color:white;min-height:500px">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/house_3.jpg" height="400" alt=""  />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">House Owners Insurance</p>
          </div>
          <div style="padding-top:20px">
          
            <p>Home Owners Insurance is essential if you own or are intending to buy a house. </p>
            <p>This covers you for damage to your main dwelling house, and other outbuildings that can be locked up. </p>
            <p>The major risks covered under this include; Fire, water damage, aerial object that may fall from the sky including falling trees.</p>
                      </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(2)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'HouseOwners',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

